export default __webpack_public_path__ + "media/zurb/img/events/wired/lsa/lsa-photos-ab3e3b245d5d584bfdc3da9d5de4deaa.png";